const applyLinkedForm = crm => ({ getState }) => {
	const state = getState();
	return state.data;
};

export default applyLinkedForm;
